<template>
    <div v-loading="loading">
        <section>
            <article class="mt-5">
            <div class="container mt-5">
                <div class="row w-100 mb-4">
                <div class="col-12 pl-3 px-0 mb-0 text-left">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/smartlodge/admin/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Messages</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                </div>
                <h1 style="font-size: 1.5em; font-weight: 600;">Messages:</h1>
                <div
                style="display: flex; align-items:center; justify-content: space-between;"
                class="search_add_section"
                >
                <div style="width: 50%;">
                    <input
                    type="text"
                    v-model.trim="filters[0].value"
                    placeholder="Search by Name"
                    class="search_by_input form-control"
                    spellcheck="off"
                    />
                </div>
                <div> </div>
                </div>
                <hr />
    
                <div
                v-loading="loading || is_changing"
                class="table-responsive mb-5"
                >
                <data-tables
                    :data="messages"
                    :table-props="tableProps"
                    :pagination-props="{ pageSizes: [5, 20, 25, 50, 100] }"
                    type="expand"
                    :filters="filters"
                >
    
                    <div slot="empty">
                    <ScaleOut
                        v-if="isLoading && !loadingError"
                        class="mt-3"
                        :background="'#164B70'"
                    />
                    <div
                        @click="getMessages"
                        v-else-if="!isLoading && loadingError"
                        style="cursor: pointer"
                    >
                        Unable to Load messages Now. Please click here to retry
                    </div>
                    <div v-if="!isLoading && !loadingError">No messages</div>
                    </div>
    
                    <el-table-column
                    label="#"
                    :show-overflow-tooltip="false"
                    label-class-name="text-center"
                    class-name="text-center"
                    width="80px"
                    >
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                    </el-table-column>
    
                    <el-table-column
                    label="Message Info"
                    :show-overflow-tooltip="false"
                    label-class-name="text-left"
                    class-name="text-left"
                    >
                    <template slot-scope="scope">
                        <!-- {{  }}<br /> -->
                        <span> {{ scope.row.name }} </span><br />
                        <small>Email: {{ scope.row.email }} </small><br />
                        <small>Phone: {{ scope.row.phone }} </small><br />
                        <small>Add On: {{ formattedDate(scope.row.created_at) }} </small>
                    </template>
                    </el-table-column>
    
                    <el-table-column
                    label="Messages"
                    :show-overflow-tooltip="false"
                    label-class-name="text-center"
                    class-name="text-center"
                    >
                    <template slot-scope="scope">
                        {{ scope.row.message }}
                    </template>
                    </el-table-column>
    
                    <el-table-column
                    label="Actions"
                    :show-overflow-tooltip="false"
                    label-class-name="text-center"
                    class-name="text-center"
                    >
                    <template slot-scope="scope">
                        <el-tooltip
                            content="Delete"
                            placement="top"
                        >
                            <el-button
                            type="danger"
                            :disabled="false"
                            @click="deleteMessage(scope.row.messageID)"
                            icon="el-icon-delete"
                            circle
                            ></el-button>
                        </el-tooltip>
                    </template>
                    </el-table-column>
    
                </data-tables>
                </div>
    
            </div>
            </article>
        </section>

        
    </div>
  </template>
  
  <script>
  import ScaleOut from "@/components/backoffice/scale-out-component.vue";
  import { format, parseISO } from "date-fns";
  export default {
    components: {
      ScaleOut,
    },
  
    data() {
      return {
        loading: false,
        isLoading: false,
        messages: [],
        
        tableProps: {
          border: true,
          stripe: true,
        },
        filters: [
          {
            prop: "name",
            value: "",
          },
        ],
        loadingError: false,
      };
    },
  
    computed: {
      formattedDate() {
        return (dateString) => format(parseISO(dateString), "do MMM yyyy hh:mma");
      },
    },
  
    mounted() {
      this.getMessages();
    },
  
    methods: {
  
      async getMessages() {
        this.isLoading = true;
        this.isLoadingError = false;
        try {
          //TODO: MAKE THIS REQUEST DYNAMIC AND NOT STATIC
          let request = await this.$http.get(`contact-us`);
          if (request.data.success && request.data.message === "MESSAGES_FETCHED_SUCCESSFULLY") {
            this.messages = request.data.messages;
          } else throw "UNEXPECTED_RESPONSE_RECEIVED";
        } catch (error) {
          this.isLoadingError = true;
          //TODO: REPORT THIS TO AN ERROR REPORTING SERVICE
          this.$notify({
            title: "Operation Failed",
            message: "Unable to fetch messages now, please try again",
            type: "error",
          });
        } finally {
          this.isLoading = false;
        }
      },
  
      async deleteMessage(messageID) {
        this.$confirm(
          // eslint-disable-line no-unreachable
          "This will permanently delete this Message. Do you want to Continue?",
          "Confirm delete",
          {
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(async () => {
            try {
              this.deleting = true;
              let request = await this.$http.delete(`contact-us/${messageID}`);
              if (
                request.data.success &&
                request.data.message === "MESSAGE_DELETED_SUCCESSFULLY"
              ) {
                this.getMessages();
                this.$notify({
                  title: "Success",
                  message: "Message deleted successfully!",
                  type: "success",
                });
              } else {
                throw "UNEXPECTED_RESPONSE";
              }
            } catch (error) {
              if (error.message == "Network Error") {
                this.loadingError = true;
                return this.$notify({
                  title: "Connection failed",
                  message: "A network error occurred, please try again.",
                  type: "error",
                });
              }
              this.$notify({
                title: "Unable to Delete",
                message: "Unable to delete the Message, Please try again",
                type: "error",
              });
            } finally {
              this.deleting = false;
            }
          })
          .catch(() => {
            //
          });
      },
    },
  };
  </script>
  
  <style>
  .el-form-item {
    margin-bottom: 0px;
  }
  
  .el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0px;
  }
  label {
    display: inline-block;
    margin-bottom: 0px;
  }
  </style>